/**
 * NutritionContent - 营养成分表渲染组件
 */

import React from 'react';

export default function NutritionContent({ data, mode = 'view', templateType }) {
  if (!data || !data.items || data.items.length === 0) return null;

  const isBlueWhiteTemplate = templateType === 'blue-white-template';
  const isStandardTemplate = templateType === 'standard-food-label';
  const ts = data.tableStyle || {};

  // 获取标题配置
  const titleConfig = data.titleConfig || {};
  const shouldShowCustomTitle = titleConfig.enabled && (titleConfig.chinese || titleConfig.english);

  // 根据模板类型设置默认颜色
  const defaultBgColor = isBlueWhiteTemplate ? '#1e90ff' : (isStandardTemplate ? '#5C4A37' : '#1e90ff');

  // 渲染标题
  const renderTitle = () => {
    if (isBlueWhiteTemplate && shouldShowCustomTitle) {
      return (
        <h3
          className="content-section-heading blue-white-title"
          style={{
            backgroundColor: titleConfig.bgColor || defaultBgColor,
            color: titleConfig.textColor || '#ffffff'
          }}
        >
          {titleConfig.english && (
            <div className="blue-white-title-en">{titleConfig.english}</div>
          )}
          <div className="blue-white-title-cn">{titleConfig.chinese || '营养成分表'}</div>
        </h3>
      );
    }
    
    return <h3 className="content-section-heading">营养成分表</h3>;
  };

  const table = (
    <div className="label-content-nutrition">
      <table className="nutrition-table" style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr style={{ background: ts.headBgColor }}>
            <th style={{ color: ts.headTextColor }}>项目</th>
            <th style={{ color: ts.headTextColor }}>每100克</th>
            <th style={{ color: ts.headTextColor }}>NRV%</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((item, idx) => (
            <tr key={idx}>
              <td style={{ color: ts.textColor, borderBottom: ts.rowBorderColor ? `1px solid ${ts.rowBorderColor}` : undefined, padding: (ts.cellPadding ?? 10) + 'px' }}>{item.name}</td>
              <td style={{ color: ts.textColor, borderBottom: ts.rowBorderColor ? `1px solid ${ts.rowBorderColor}` : undefined, padding: (ts.cellPadding ?? 10) + 'px' }}>{item.per100g}{item.unit}</td>
              <td style={{ color: ts.textColor, borderBottom: ts.rowBorderColor ? `1px solid ${ts.rowBorderColor}` : undefined, padding: (ts.cellPadding ?? 10) + 'px' }}>{item.nrv}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div
        style={{
          marginTop: 8,
          fontSize: 12,
          color: '#4b5563',
          paddingLeft: 12
        }}
      >
        儿童青少年应避免过量摄入盐油糖。
      </div>
    </div>
  );

  // 蓝白：标题在卡片外；默认/其它：标题在卡片内
  if (isBlueWhiteTemplate) {
    return (
      <>
        {renderTitle()}
        {table}
      </>
    );
  }
  return (
    <div className="label-content-nutrition">
      {renderTitle()}
      {table.props.children}
    </div>
  );
}
